import React, { useState } from "react";
import "../styles/ClubPage.css";
import { formatDate } from "../utils/dateUtils"; // ✅ Import function




const PastParticipation = ({ clubData }) => {
    const [showAll, setShowAll] = useState(false);

    if (!clubData || !clubData.participations) return <p>Loading past participations...</p>;

    const today = new Date();

    // Filter past events (date_end before today) and sort by latest first
    const pastEvents = clubData.participations
        .filter(event => event.date_end?.seconds && new Date(event.date_end.seconds * 1000) < today)
        .sort((a, b) => b.date_end.seconds - a.date_end.seconds);

    // Limit to 3 if showAll is false
    const visibleEvents = showAll ? pastEvents : pastEvents.slice(0, 3);

    return (
        <>
            <h2>Past Participation</h2>
            <div className="past-participate-grid">
                {visibleEvents.length > 0 ? (
                    visibleEvents.map((event, index) => (
                        <div key={index} className="past-event-card">
                            {/* ✅ Standardize image size & expand to column width */}
                            {event.media?.length > 0 && event.media[0].startsWith("http") && (
                                <img className="event-image" src={event.media[0]} alt={event.name} />
                            )}
                            <h3>{event.name}</h3>
                            <p><strong>Location:</strong> {event.location}</p>
                            <p>
                                <strong>Date:</strong>{" "}
                                {formatDate(event.date_start)}
                                {event.date_end && formatDate(event.date_start) !== formatDate(event.date_end) && (
                                    <> to {formatDate(event.date_end)}</>
                                )}
                            </p>
                        </div>
                    ))
                ) : (
                    <p>No past events found.</p>
                )}
            </div>

            {/* Show "See More" if more than 3 events exist */}
            {pastEvents.length > 3 && (
                <button onClick={() => setShowAll(!showAll)}>
                    {showAll ? "See Less" : "See More"}
                </button>
            )}
        </>
    );
};

export default PastParticipation;
